/* eslint-disable max-len */
import { useInfiniteQuery } from '@tanstack/react-query';

import { PUBLISHING_KD } from 'src/constants/services';
import { Pagination, ResponseData } from 'src/interface/Commons';
import { Event } from 'src/interface/Event';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';

export const listEventQueryKey = 'listEvent';

export const useListEvent = (
	eventStatus: 'upcoming' | 'ongoing',
	payload?: Record<string, any>,
	options?: { enabled?: boolean },
) => {
	const eventPayload = {
		page: 1,
		per_page: 2,
		event_status: eventStatus,
		...payload,
	};

	const { data, ...restAttributes } = useInfiniteQuery({
		queryKey: [listEventQueryKey, eventStatus, eventPayload],
		queryFn: ({ pageParam = 1 }: { pageParam?: any }): Promise<ResponseData<{ records: Event[] }, Pagination>> =>
			fetchApiV3Publishing({
				url: `/${PUBLISHING_KD.service}/${PUBLISHING_KD.model.events}`,
				options: {
					method: 'GET',
				},
				payload: {
					...eventPayload,
					page: pageParam,
				},
			}),
		enabled: options?.enabled,
		refetchOnWindowFocus: false,
		getNextPageParam: (res) => {
			const pagination = res.meta.pagination;
			return pagination.page < pagination.total_page ? pagination.page + 1 : undefined;
		},
		initialPageParam: 1,
	});

	const flattenedData = data?.pages?.flatMap?.((v) => v.data.records);

	return {
		data: flattenedData,
		dataLength: flattenedData?.length,
		...restAttributes,
	};
};
